import Highcharts from 'highcharts';
import { filterByCategory } from "../ranking-sm/data.js";

function getMandatyFinanse() {
    const categories = [
        'Mandaty: liczba wystawionych',
        'Etaty: liczba strażników',
        'Budżet',
        'Mandaty: wartość',
        'Mandaty: liczba wystawionych dot. PRD',
        'Mandaty: wartość wystawionych dot. PRD',
        'Pouczenia: liczba'
    ];
    const data = filterByCategory(categories);

    const validData = data.filter(sm =>
        sm['Mandaty: liczba wystawionych'] !== null &&
        sm['Etaty: liczba strażników'] !== null &&
        sm['Budżet'] !== null &&
        sm['Mandaty: wartość'] !== null &&
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Etaty: liczba strażników'] === 'number' &&
        typeof sm['Budżet'] === 'number' &&
        typeof sm['Mandaty: wartość'] === 'number'
    );

    validData.forEach(sm => {
        sm.finesPerGuardMonthly = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Etaty: liczba strażników'] / 12) * 10) / 10;
        sm.selfFinancingRate = Math.round((sm['Mandaty: wartość'] / sm['Budżet']) * 100 * 10) / 10;
        if (sm['Mandaty: wartość wystawionych dot. PRD'] && sm['Mandaty: liczba wystawionych dot. PRD']) {
            sm.avgPrdFine = Math.round(sm['Mandaty: wartość wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych dot. PRD']);
        } else {
            sm.avgPrdFine = null;
        }
    });

    return validData.sort((a, b) => b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}

export function chartMandaty(id) {
    if (!document.getElementById(id)) return;

    const data = getMandatyFinanse();

    const categories1 = data.map(item => item.city);
    const finesPerGuardData = data.map(item => item.finesPerGuardMonthly);
    const avgFineData = data.map(item => item.avgPrdFine || 0);

    const sumOfMandaty = data.reduce((sum, city) => sum + city['Mandaty: wartość wystawionych dot. PRD'], 0)
    const countOfMandaty = data.reduce((sum, city) => sum + city['Mandaty: liczba wystawionych dot. PRD'], 0)
    const average = sumOfMandaty / countOfMandaty

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Fine productivity and average fine amount' },
        xAxis: {
            categories: categories1,
            type: 'category',
            title: { text: null },
            labels: { style: { fontSize: '16px' } }
        },
        yAxis: [{
            title: { text: null },
            labels: { style: { color: '#999' }, format: '{value} PLN' },
            opposite: true,
            plotLines: [{
                value: average,
                color: '#999',
                dashStyle: 'ShortDot',
                width: 3,
                zIndex: 5,
                label: {
                    text: `Average: ${average.toFixed(0)} PLN`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: '#000', fontWeight: 'bold' }
                }
            }]
        }, {
            min: 0,
            title: { text: null },
            labels: { style: { color: '#e74c3c' } }
        }],
        legend: { enabled: false },
        tooltip: { shared: true },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.series.name === 'Average traffic fine (PRD)') {
                            return this.y ? `${this.y} PLN` : '';
                        } else {
                            return this.y;
                        }
                    }
                }
            },
            series: { grouping: false, borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'Average traffic fine (PRD)',
            type: 'bar',
            yAxis: 0,
            data: avgFineData,
            color: '#999',
            linkedTo: 'main',
            pointPlacement: -0.2
        }, {
            name: 'Traffic fines per guard (monthly)',
            type: 'bar',
            yAxis: 1,
            data: finesPerGuardData,
            color: '#e74c3c',
            id: 'main'
        }]
    });
}


export function chartSelfinancing(id) {
    const data = getMandatyFinanse();
    const data2 = [...data].sort((a, b) => b.selfFinancingRate - a.selfFinancingRate);
    const categories = data2.map(item => item.city);
    const selfFinancingData = data2.map(item => item.selfFinancingRate);
    const backgroundData = selfFinancingData.map(() => 100);

    const avg = selfFinancingData.reduce((a, b) => a + b, 0) / selfFinancingData.length

    const barColor = '#27ae60';
    const belowAvgColor = '#548067';

    const selfFinancingDataWithColor = data2.map(item => ({
        y: item.selfFinancingRate,
        color: item.selfFinancingRate >= avg ? barColor : belowAvgColor
    }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Budget coverage ratio' },
        subtitle: { text: 'Share of annual city guard budget recovered through fines' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: '%' },
            min: 0,
            max: 100,
            labels: { format: '{value}%' }
        },
        legend: { enabled: false },
        tooltip: { valueSuffix: '%' },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: { enabled: true, format: '{y}%' }
            },
            series: { borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'Budget',
            data: backgroundData,
            color: '#ecf0f1',
            enableMouseTracking: false,
            dataLabels: { enabled: false }
        }, {
            name: 'Budget coverage',
            data: selfFinancingDataWithColor,
            color: '#27ae60'
        }]
    });
}

/**
 * @param {string} id
 */
export function chartPriceOfFine(id) {
    const data = getMandatyFinanse()

    data.forEach(sm => {
        sm.pricePerAction = Math.round(sm['Budżet'] /
            (sm['Mandaty: liczba wystawionych'] + (sm['Pouczenia: liczba'] || 0)))
        sm.pricePerFine = Math.round(sm['Budżet'] /
            (sm['Mandaty: liczba wystawionych']))
    })

    const data2 = [...data].sort((a, b) => b.pricePerAction - a.pricePerAction);
    const categories = data2.map(item => item.city);
    const pricePerActionData = data2.map(item => item.pricePerAction);
    const pricePerFineData = data2.map(item => item.pricePerFine);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'City Guard budget per fine or warning' },
        subtitle: { text: 'Cost of issuing a single fine or warning' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: '' },
            labels: { format: '{value} PLN' }
        },
        legend: { enabled: true, verticalAlign: 'top', reversed: true },
        tooltip: { valueSuffix: ' PLN', shared: true },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: { enabled: true, format: '{y} PLN' }
            },
            series: { borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'Budget per fine',
            data: pricePerFineData,
            color: '#999',
        }, {
            name: 'Budget per fine or warning',
            data: pricePerActionData,
            color: '#a70000',
            dataLabels: { inside: true }
        }]
    });
}
